const initPropertyHeroGallery = () => {
  const galleries = document.querySelectorAll('[data-property-hero-gallery]');

  if (!galleries.length) {
    return;
  }

  const root = document.documentElement;
  const header = document.querySelector('.site-header');

  const setHeaderHeight = () => {
    const headerHeight = header ? header.offsetHeight : 0;
    root.style.setProperty('--property-hero-header-height', `${headerHeight}px`);
  };

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  if (header && 'ResizeObserver' in window) {
    const observer = new ResizeObserver(() => setHeaderHeight());
    observer.observe(header);
  }

  const swipeThreshold = 30;

  galleries.forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('[data-hero-gallery-slide]'));
    const prevButton = gallery.querySelector('[data-hero-gallery-prev]');
    const nextButton = gallery.querySelector('[data-hero-gallery-next]');
    const viewport = gallery.querySelector('[data-hero-gallery-viewport]');
    const slideTrack = gallery.querySelector('[data-hero-gallery-slides]');

    if (!slides.length) {
      return;
    }

    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (activeIndex < 0) {
      activeIndex = 0;
    }

    const setActiveSlide = (nextIndex) => {
      slides.forEach((slide, index) => {
        const isActive = index === nextIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      activeIndex = nextIndex;
    };

    const goTo = (direction) => {
      const slideCount = slides.length;
      const nextIndex = (activeIndex + direction + slideCount) % slideCount;
      setActiveSlide(nextIndex);
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        goTo(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        goTo(1);
      });
    }

    if (viewport) {
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(1);
        }
      });
    }

    if (slideTrack) {
      let pointerId = null;
      let startX = 0;
      let isPointerActive = false;

      const resetSwipe = () => {
        pointerId = null;
        startX = 0;
        isPointerActive = false;
      };

      slideTrack.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) {
          return;
        }
        isPointerActive = true;
        pointerId = event.pointerId;
        startX = event.clientX;
        slideTrack.setPointerCapture(pointerId);
      });

      slideTrack.addEventListener('pointerup', (event) => {
        if (!isPointerActive || event.pointerId !== pointerId) {
          return;
        }

        slideTrack.releasePointerCapture(pointerId);
        const deltaX = event.clientX - startX;
        resetSwipe();

        if (Math.abs(deltaX) < swipeThreshold) {
          return;
        }

        if (deltaX > 0) {
          goTo(-1);
        } else {
          goTo(1);
        }
      });

      slideTrack.addEventListener('pointercancel', () => {
        if (pointerId !== null) {
          slideTrack.releasePointerCapture(pointerId);
        }
        resetSwipe();
      });
    }

    setActiveSlide(activeIndex);
  });
};

export default initPropertyHeroGallery;
